import { MdCheckBox, MdRadioButtonChecked, MdShortText, MdTune } from "react-icons/md";

const TEXT_TYPES = ["text", "textarea", "short_text", "long_text"];
const NUMERIC_TYPES = ["slider", "scale"];

export const isTextQuestion = (type) => TEXT_TYPES.includes(type);
export const isNumericQuestion = (type) => NUMERIC_TYPES.includes(type);
export const isChoiceQuestion = (type) => type === "single_choice" || type === "multiple_choice";

/** Display metadata for a question type: icon, short label and one-line description. */
export const getQuestionTypeMeta = (type) => {
  if (isNumericQuestion(type)) {
    return {
      icon: MdTune,
      label: "Scale (1-5)",
      description: "Respondents rated this question on a scale from 1 to 5",
    };
  }
  if (type === "single_choice") {
    return {
      icon: MdRadioButtonChecked,
      label: "Single Choice",
      description: "Respondents selected one option",
    };
  }
  if (type === "multiple_choice") {
    return {
      icon: MdCheckBox,
      label: "Multiple Choice",
      description: "Respondents could select multiple options",
    };
  }
  if (isTextQuestion(type)) {
    return {
      icon: MdShortText,
      label: "Text Response",
      description: "Respondents provided written answers",
    };
  }
  return { icon: MdShortText, label: "Unknown", description: "" };
};
